import { combineReducers } from "redux";

import authStoreReducer from "./authStore";
import apiStoreReducer from "./apiStore";

const rootReducer = combineReducers({
  auth: authStoreReducer,
  apis: apiStoreReducer,
});

export default rootReducer;
